import React from "react";
import Select from 'react-select';
import { useFormContext } from 'react-hook-form';
import HelperText from '@ingka/helper-text';
import { findInputError } from '../utils/findInputError';
import { isFormInvalid } from '../utils/isFormInvalid';
import ls from '../services/localStorage';

export const SelectComp = ({ label, name, validation, placeholder, id, value, options, handleSelectChange }) => {
  const { setValue, getValues, formState: { errors } } = useFormContext();
  const inputErrors = findInputError(errors, name);
  const isInvalid = isFormInvalid(inputErrors);

  React.useEffect(() => {
    if (name === 'receiving_unit_code' && ls.get('user-store-id') !== 'SO') {
      value = ls.get('user-store-id');
      setValue(name, value);
    } else if (value !== undefined || value !== '') {
      setValue(name, value);
    }
  }, [name, value, setValue]);

  const InputError = ({ message }) => (
    <HelperText shouldValidate>{message}</HelperText>
  );
//-------
 // ✅ Handle options safely (object or array)
let selectOptions = [];

if (Array.isArray(options)) {
  // already array of { value, label }
  selectOptions = options.map(opt => ({
    value: opt.value,
    label: opt.label
  }));
} else if (typeof options === "object" && options !== null) {
  // object like { "1": "Kg", "2": "Gram" }
  selectOptions = Object.entries(options).map(([key, label]) => ({
    value: `${key}-${String(label).replace(/\s+/g, "_")}`,
    label: `${key} - ${label}`
  }));
}
//-------
  const handleChange = (selectedOption) => {
    setValue(name, selectedOption ? selectedOption.value : '');
    if (name === 'type') {
      handleSelectChange?.(selectedOption?.value || '');
    }
  };

  // Set the default value for react-select
  const defaultOption = selectOptions.find(opt => opt.value === value);

  const isDisabled = (value !== '' && value !== undefined && (name === 'supplier_number' || name === 'receiving_unit_code'));

  return (
    <div style={{ marginBottom: '1rem' }}>
      <label htmlFor={id} style={{ display: 'block', marginBottom: '0.5rem' }}>{label}</label>
   <Select
  id={id}
  name={name}
  options={selectOptions}
  value={defaultOption}
  onChange={handleChange}
  isDisabled={isDisabled}
  placeholder={placeholder || 'Choose an option'}
  isClearable
  isSearchable
  classNamePrefix="custom-select"
/>


      {isInvalid && <InputError message={inputErrors.error.message} />}
    </div>
    
  );
  
};